<!-- Header -->
<header>
  <nav class="navbar navbar-expand-lg navbar-light bg-light shadow fixed-top">
    <div class="container-fluid" >
      @if (defaultimg) {
        <img src="\assets\images\Accenture-logo.png" alt=""  >
      }

      @if (hwmainnewimg) {
        <div class="container" style="width: 300px;">
          <img src="../../../assets/images/accenture-log.png" class="centered-image">
          <p class="centered-text">Well-being Analytics</p>
        </div>
      }
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item active">
            <marquee> <label style="font-size: 16px;width:950px;">{{headerText}}</label></marquee>
          </li>
        </ul>
      </div>
      <ul class="navbar-nav ms-auto">

        <li class="nav-item active" style="font-size: 14px;">
          Welcome <span ngDefaultControl >{{username}}</span>
        </li>
      </ul>

    </div>





  </nav>

  @if (health) {
    <nav class="navbar navbar-expand-lg navbar-light bg-light shadow fixed-top" style="margin-top:70px">
      <div class="container-fluid" >
        <div class="row">
          <div class="col-sm" >
            <button (click)="new_showComponent('TextAnalysis')" class="button-cls">Home</button>
          </div>
          <div class="col-sm" >
            <button (click)="new_showComponent('landingjobprofile')" class="button-cls">Job Matching</button>
          </div>
          <div class="col-sm" style="display:none" >
            <button (click)="new_showComponent('')" title="Coming Soon" class="button-cls-inactive">Word Cloud</button>
            <span> </span>
          </div>
          <div class="col-sm" style="display:none" >
            <button (click)="new_showComponent('')"  title="Coming Soon"class="button-cls-inactive">Theme Identification</button>
          </div>
          <div class="col-sm" style="display:none" >
            <button (click)="new_showComponent('')" title="Coming Soon" class="button-cls-inactive">Sentiment Analysis</button>
          </div>
          <!-- <div class="col-sm" >
          <button (click)="new_showComponent('')" title="Coming Soon" class="button-cls-inactive">Name Entity Recognition</button>
        </div> -->
        <div class="col-sm" style="display:none" >
          <button (click)="new_showComponent('')"  title="Coming Soon" class="button-cls-inactive">Part of Speech Tagging</button>
        </div>
        <div class="col-sm"  style="display:none">
          <button (click)="new_showComponent('')"  title="Coming Soon" class="button-cls-inactive">Text Summarizer</button>
        </div>
        <div class="col-sm" style="display:none" >
          <button (click)="new_showComponent('')"  class="button-cls-inactive">Well-being Analytics</button>
        </div>
        <!-- <div class="col-sm" >
        <button (click)="new_showComponent('powerbi')"  class="button-cls-inactive">Powerbi</button>
      </div>  -->
      <!-- <div class="col-sm" >
      <button (click)="new_showComponent('')"  title="Coming Soon"class="button-cls-inactive">Admin Panel</button>
    </div> -->
  </div>
</div>
</nav>
}






</header>
<!-- /Header -->